// src/pages/ApplicationChampionshipStageStandings/utils/buildSavePayload.ts
//
// Monta o payload de PUT /standings/:id a partir dos campos editáveis,
// preenchendo os derivados (played, goal_diff, win_rate) calculados no front.

import { StandingEditableFields } from '../types';
import { calcGoalDiff, calcPlayed, calcWinRate } from './calculateStandingDerived';

export const buildSavePayload = (changes: StandingEditableFields) => {
  const played = calcPlayed(changes.wins, changes.draws, changes.losses);
  const goalDiff = calcGoalDiff(changes.goals_for, changes.goals_against);
  const winRate = calcWinRate(changes.points, played);
  return {
    points: changes.points,
    wins: changes.wins,
    draws: changes.draws,
    losses: changes.losses,
    goals_for: changes.goals_for,
    goals_against: changes.goals_against,
    played,
    goal_diff: goalDiff,
    win_rate: winRate === null ? undefined : winRate,
  };
};
